module.exports = __webpack_public_path__ + "static/media/Union.7620908a.svg";